import { useEffect } from 'react';
import { ROUTE_START_LOCATION } from '../../../../../../../constants/Routes';
import { Stop } from '../../../../../../../domain/stops/Stop';
import { PRIVATE_COMPONENT_ID } from '../../../../../PrivateComponent';
import { useRouteContext } from '../../../../context/context';
import { useUpdateRoute } from '../../../../hooks/useUpdateRoute';
import { EditStopAddress } from '../../../create-stops/bulk/EditStopAddress';
import { ValidatedAddress } from '../../../create-stops/bulk/ValidateStopsBulk';

interface EditStartOrEndLocationProps {
  stop: Stop;
  isOpen: boolean;
  close: () => void;
}

export const EditStartOrEndLocation = ({ stop, isOpen, close }: EditStartOrEndLocationProps) => {
  const { routeState } = useRouteContext();

  const { error, success, isLoading, run: updateRoute } = useUpdateRoute();

  useEffect(() => {
    if (isLoading && success) {
      close();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  return (
    <EditStopAddress
      isOpen={isOpen}
      isLoading={isLoading}
      initialValidatedAddress={
        {
          rawAddress: stop.location?.label ?? ``,
          location: stop.location,
          status: `successful`,
        } as ValidatedAddress
      }
      onUpdate={(newValidatedAddress) => {
        updateRoute({
          route: routeState.route!,
          ...(stop.id === ROUTE_START_LOCATION
            ? { start_location: newValidatedAddress.location }
            : { end_location: newValidatedAddress.location }),
        });
      }}
      onClose={() => {
        if (!isLoading || error) close();
      }}
      portalElementId={PRIVATE_COMPONENT_ID}
    />
  );
};
